import {
  // reason: this is the wrapped component which we will allow since this is the exported version
  // eslint-disable-next-line @dhl/dhl-ui/no-restricted-imports
  Skeleton as MuiSkeleton,
  type SkeletonProps as MuiSkeletonProps,
} from '@mui/material'
import { SkeletonTextSize } from './text-size'
import { type DataTestIdAttribute, type MinimalSxProp } from '../../types'
import { mergeSx } from '../../helpers'

type BaseProps = Pick<MuiSkeletonProps, 'animation' | 'children' | 'height' | 'width'> &
  DataTestIdAttribute &
  MinimalSxProp

type PropsNotTextVariant = BaseProps & {
  variant: 'rectangular' | 'rounded' | 'circular'

  /**
   * A textVariant is only allowed on variant 'text'
   */
  textVariant?: never
}

type PropsTextVariant = BaseProps & {
  variant?: 'text'

  /**
   * When placing Skeleton not inside Typography element you can emulate the Text variant with a specific size
   * This is only allowed to be set inside a variant 'text' (our default variant)
   */
  textVariant?: keyof typeof SkeletonTextSize
}

export type SkeletonProps = PropsNotTextVariant | PropsTextVariant

/**
 * Display a placeholder preview of your content before the data gets loaded to reduce load-time frustration.
 *
 * - [Skeleton](https://design-system.accept.cl1.intra.dhlparcel.io/?path=/docs/primitives-skeleton--docs)
 */
export const Skeleton = ({ children, sx, textVariant, ...rest }: SkeletonProps) => (
  <MuiSkeleton {...rest} sx={mergeSx(sx, textVariant ? { fontSize: SkeletonTextSize[textVariant] } : {})}>
    {children}
  </MuiSkeleton>
)
